import { GalleryAdditionalVisualsContextProvider, GalleryAssignmentContextProvider, GalleryConstantsContextProvider, GalleryDealContextProvider, GalleryOrderContextProvider, GalleryProductContextProvider, GalleryVirtualVisitContextProvider, GalleryVisualSelectionContextProvider, GalleryVisualTypeContextProvider, GalleryVisualsContextProvider, GalleryVisualsDownloadArchiveContextProvider, GalleryVisualsEditingStackProvider, GalleryVisualsMetaContextProvider } from 'components/pages/Gallery/_main/contexts'
import { useLocation, useParams } from 'react-router-dom'

import { ClientGalleryContextProvider } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { ClientPropertyGalleryExportOptionsFlowPage } from './ClientPropertyGalleryExportOptionsFlowPage.page'
import { FC } from 'react'

export const ClientPropertyExportingOptions: FC = () => {
  const { assignmentId } = useParams<{ id?: string, assignmentId?: string }>()
  const location = useLocation()

  if (!assignmentId) return null

  return (
    <GalleryConstantsContextProvider>
      <GalleryAssignmentContextProvider assignmentId={assignmentId}>
        <GalleryDealContextProvider assignmentId={assignmentId} keepPreviousData={true}>
          <GalleryVisualTypeContextProvider assignmentId={assignmentId}>
            <GalleryProductContextProvider assignmentId={assignmentId}>
              <GalleryOrderContextProvider assignmentId={assignmentId}>
                <GalleryVisualsMetaContextProvider assignmentId={assignmentId}>
                  <GalleryVisualsContextProvider assignmentId={assignmentId}>
                    <GalleryVirtualVisitContextProvider assignmentId={assignmentId}>
                      <GalleryVisualSelectionContextProvider assignmentId={assignmentId}>
                        <GalleryAdditionalVisualsContextProvider assignmentId={assignmentId}>
                          <GalleryVisualsDownloadArchiveContextProvider assignmentId={assignmentId}>
                            <GalleryVisualsEditingStackProvider assignmentId={assignmentId}>
                              <ClientGalleryContextProvider assignmentId={assignmentId}>

                                <ClientPropertyGalleryExportOptionsFlowPage selectedVisuals={location.state.selectedVisuals} />

                              </ClientGalleryContextProvider>
                            </GalleryVisualsEditingStackProvider>
                          </GalleryVisualsDownloadArchiveContextProvider>
                        </GalleryAdditionalVisualsContextProvider>
                      </GalleryVisualSelectionContextProvider>
                    </GalleryVirtualVisitContextProvider>
                  </GalleryVisualsContextProvider>
                </GalleryVisualsMetaContextProvider>
              </GalleryOrderContextProvider>
            </GalleryProductContextProvider>
          </GalleryVisualTypeContextProvider>
        </GalleryDealContextProvider>
      </GalleryAssignmentContextProvider>
    </GalleryConstantsContextProvider>
  )
}
